import {I18n} from '@aws-amplify/core';
import {PaymentMethod} from '../types';
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {Badge} from "@mantine/core";

export const getColumns = (onRecordClick?: (record: PaymentMethod) => void) => [
    {
        title: I18n.get('Type'),
        width: '1fr',
        render: (item: PaymentMethod) => onRecordClick ? (
            <span
                style={{color: 'var(--mantine-color-blue-6)', cursor: 'pointer'}}
                onClick={() => onRecordClick(item)}
            >
                <Badge variant="light">{item.type}</Badge>
            </span>
        ) : <Badge variant="light">{item.type}</Badge>,
    },
    {
        title: I18n.get('Last 4'),
        width: '1fr',
        render: (item: PaymentMethod) => item.card?.last4 || '-',
    },
    {
        title: I18n.get('Brand'),
        width: '1fr',
        render: (item: PaymentMethod) => item.card?.brand || '-',
    },
    {
        title: I18n.get('Customer'),
        width: '1fr',
        render: (item: PaymentMethod) => item.customerId,
    },
    {
        title: I18n.get('Expiry'),
        width: '1fr',
        render: (item: PaymentMethod) => item.card ? `${item.card.expMonth}/${item.card.expYear}` : '-',
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: PaymentMethod) => formatTimestamp(item.created * 1000),
    },
];

// Keep backward-compatible export for any remaining consumers
export const columns = getColumns();
